var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 22,
    viewBox: "0 0 97 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Bubble_Logo_no_code 1",
    clipPath: "url(#clip0_203_217920)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_203_217920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 22
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M97 0H0V22H97V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_203_217920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M47.277 5.85687C45.318 5.85687 43.3872 6.68905 41.9132 8.32514V0.256958H38.9961V13.8402C38.9961 13.8406 38.9961 13.8409 38.9961 13.8413C38.9961 18.2509 42.6087 21.8255 47.0652 21.8255C51.5217 21.8255 55.1343 18.2509 55.1343 13.8413C55.1343 9.43166 51.7334 5.85687 47.277 5.85687ZM47.0652 18.7503C44.3252 18.7503 42.104 16.5524 42.104 13.8412C42.104 11.13 44.3252 8.93208 47.0652 8.93208C49.8053 8.93208 52.0265 11.13 52.0265 13.8412C52.0265 16.5524 49.8053 18.7503 47.0652 18.7503Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_203_217920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 22
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M97 0H0V22H97V0Z",
    fill: "white"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_203_217920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.3473 5.85687C63.3883 5.85687 61.4575 6.68905 59.9834 8.32514V0.256958H57.0665V13.8402C57.0665 13.8406 57.0664 13.8409 57.0664 13.8413C57.0664 18.2509 60.6791 21.8255 65.1356 21.8255C69.5919 21.8255 73.2046 18.2509 73.2046 13.8413C73.2046 9.43166 69.8036 5.85687 65.3473 5.85687ZM65.1356 18.7503C62.3955 18.7503 60.1743 16.5524 60.1743 13.8412C60.1743 11.13 62.3955 8.93208 65.1356 8.93208C67.8755 8.93208 70.0968 11.13 70.0968 13.8412C70.0968 16.5524 67.8755 18.7503 65.1356 18.7503Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_203_217920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 22
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M97 0H0V22H97V0Z",
    fill: "white"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_203_217920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M22.582 15.2397V6.28992H25.7108V15.2116C25.7108 17.4913 27.0476 18.9548 29.2946 18.9548C31.5701 18.9548 32.8785 17.5476 32.8785 15.2116V6.28992H36.0357V15.2397C36.0357 19.3769 33.5042 21.8255 29.2946 21.8255C25.1987 21.8255 22.582 19.2925 22.582 15.2397Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_4"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_203_217920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 22
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M97 0H0V22H97V0Z",
    fill: "white"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_203_217920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M78.8514 0.256958H75.7227V21.4596H78.8514V0.256958Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_5"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_203_217920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 22
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M97 0H0V22H97V0Z",
    fill: "white"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_203_217920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M96.5609 15.071H84.5863C85.0414 17.4351 86.7195 19.0393 89.6776 19.0393C91.4127 19.0393 93.5174 18.392 94.8828 17.407L96.1912 19.6866C94.6268 20.8406 92.1523 21.7974 89.5638 21.7974C83.8183 21.7974 81.3438 17.8291 81.3438 13.8326C81.3438 11.5529 82.0549 9.66725 83.5055 8.17557C84.9561 6.68394 86.8619 5.92407 89.1657 5.92407C91.3557 5.92407 93.1761 6.59955 94.5699 7.97854C95.9636 9.35764 96.6746 11.2151 96.6746 13.5792C96.6746 14.0015 96.6461 14.5081 96.5609 15.071ZM84.5863 12.5379H93.5174C93.2615 10.1457 91.4696 8.59783 89.1657 8.59783C86.8048 8.59783 85.0414 10.1738 84.5863 12.5379Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_203_217920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 22
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M97 0H0V22H97V0Z",
    fill: "white"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_203_217920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M12.648 5.85687C10.6891 5.85687 8.75829 6.68905 7.28422 8.32514V0.256958H4.36719V13.8402C4.36719 13.8406 4.36719 13.8409 4.36719 13.8413C4.36719 18.2509 7.97984 21.8255 12.4363 21.8255C16.8928 21.8255 20.5055 18.2509 20.5055 13.8413C20.5055 9.43166 17.1045 5.85687 12.648 5.85687ZM12.4363 18.7503C9.6963 18.7503 7.47506 16.5524 7.47506 13.8412C7.47506 11.13 9.6963 8.93208 12.4363 8.93208C15.1763 8.93208 17.3976 11.13 17.3976 13.8412C17.3976 16.5524 15.1763 18.7503 12.4363 18.7503Z",
    fill: "#262626"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_7"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask6_203_217920",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 97,
    height: 22
  }, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "SVGID_2__7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M97 0H0V22H97V0Z",
    fill: "white"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_203_217920)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M2.24537 17.8767C1.14333 17.8767 0.25 18.7607 0.25 19.8511C0.25 20.9415 1.14333 21.8255 2.24537 21.8255C3.34741 21.8255 4.24073 20.9415 4.24073 19.8511C4.24073 18.7607 3.34741 17.8767 2.24537 17.8767Z",
    fill: "#0000FF"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_203_217920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubble);
export default __webpack_public_path__ + "static/media/Bubble.9bfcc770875771eff432bebd017f4223.svg";
export { ForwardRef as ReactComponent };